import React, { useContext } from "react";
import {
  Card,
  CardContent,
  Typography,
  makeStyles,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@material-ui/core";
import { FiChevronRight } from "react-icons/fi";
import useReactRouter from "use-react-router";
import { UserContext } from "../../Context/UserContext";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  user: {
    width: "100%",
    height: "9rem",
    backgroundColor: "#7c7c7c",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    "& .MuiCardContent-root:last-child": {
      paddingBottom: 12,
    },
  },
  userroot: {
    width: "100%",
    height: "100%",
  },
  maintext: {
    color: "#FFFFFF",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  roletext: {
    fontWeight: 200,
    fontSize: "1.2rem",
    color: "#BFC0BF",
  },
  muilist: {
    paddingTop: "unset",
    paddingBottom: "unset",
    "& .MuiListItem-gutters": {
      padding: "13px 26px 13px 26px",
    },
  },
}));

const Configlist = ({ choice, setChoice, role, setopen, open }) => {
  const classes = useStyle();
  const { history, location } = useReactRouter();
  const userContext = useContext(UserContext);
  const user = userContext.state;
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const list = [
    { title: lang.PersonalInfo, path: "/app/user/main" },
    {
      title:
        user.mea === null && user.role !== "admin" && user.role !== "root"
          ? lang.BillingInfo
          : null,
      path:
        user.mea === null && user.role !== "admin" && user.role !== "root"
          ? "/app/user/billing"
          : null,
    },
    {
      title:
        user.google === null && user.facebook === null && user.mea === null
          ? lang.ChangePassword
          : null,
      path:
        user.google === null && user.facebook === null && user.mea === null
          ? "/app/user/change-password"
          : null,
    },
  ];

  return (
    <>
      <div className={classes.userroot}>
        <Card className={classes.user}>
          <CardContent>
            <Typography className={classes.maintext}>
              {`${user.first_name
                .charAt(0)
                .toUpperCase()}${user.first_name.slice(
                1
              )} ${user.last_name
                .charAt(0)
                .toUpperCase()}${user.last_name.slice(1)}`}
            </Typography>
            <Typography className={classes.roletext}>
              {`${user.role
                .split("_")
                .join(" ")
                .charAt(0)
                .toUpperCase()}${user.role.split("_").join(" ").slice(1)}`}
            </Typography>
          </CardContent>
        </Card>
        <List className={classes.muilist} style={{ margin: "1.5rem 0rem" }}>
          {list
            .filter((rs) => {
              return rs.title !== null;
            })
            .map((item, index) => {
              return (
                <ListItem
                  key={item.title}
                  button
                  selected={location.pathname === item.path}
                  onClick={() => {
                    setChoice(index);
                    history.push(item.path);
                    setopen(false);
                  }}
                  // style={{ marginBottom: "1rem", borderRadius: "2rem" }}
                >
                  <ListItemText
                    disableTypography
                    style={{
                      color:
                        location.pathname === item.path ? "#E16733" : "#595A5A",
                      fontSize: "1rem",
                      fontWeight: location.pathname === item.path ? 400 : 200,
                    }}
                  >
                    {item.title}
                  </ListItemText>
                  <ListItemIcon style={{ minWidth: "unset" }}>
                    <FiChevronRight
                      style={{ color: "#E16733", fontSize: "1.5rem" }}
                    />
                  </ListItemIcon>
                </ListItem>
              );
            })}
        </List>
      </div>
    </>
  );
};

export default Configlist;
